import { makeStyles, Toolbar as MuiToolbar } from '@material-ui/core';

import { Menus } from '../menu/Menus';
import { PageTitle } from '../main/PageTitle';
import SiteIcon from 'src/components/ui/SiteIcon';
import SiteLogo from '../../ui/SiteLogo';

import { PathBuilder } from 'src/routing';
import { useIsSmallScreen } from 'src/helpers/ui';
import { UserProfile } from '../../../models';

export interface ToolbarProps {
  profile: UserProfile;
  title?: string;
}

export const Toolbar = ({ profile, title }: ToolbarProps) => {
  const classes = useStyles();
  const isSmallScreen = useIsSmallScreen();

  return (
    <MuiToolbar className={classes.root}>
      <div className={classes.logoBg}>
        {isSmallScreen ? (
          <SiteIcon customerId={profile.customerId} isDark={false} />
        ) : (
          <SiteLogo
            customerId={profile.customerId}
            isTitleBar={true}
            link={PathBuilder.PORTFOLIO()}
          />
        )}
      </div>
      {!isSmallScreen && <PageTitle siteName={title} />}
      <Menus profile={profile} />
    </MuiToolbar>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingRight: 0,
    backgroundColor: '#FFF',
    paddingLeft: 288,

    [theme.breakpoints.down('sm')]: {
      backgroundColor: theme.sidebar.main,
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0px 16px',
      width: '100%',
    },
  },
  logoBg: {
    alignItems: 'center',
    backgroundColor: theme.sidebar.main,
    display: 'flex',
    height: '64px',
    left: '0',
    paddingLeft: 16,
    position: 'absolute',
    width: '256px',
    zIndex: 100,

    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      padding: 0,
    },

    '&:before': {
      [theme.breakpoints.up('sm')]: {
        zIndex: -1,
        transform: 'rotateZ(15deg)',
        position: 'absolute',
        content: '""',
        display: 'block',
        right: -11,
        bottom: 5,
        height: 77,
        width: 48,
        backgroundColor: theme.sidebar.main,
      },
    },
  },
}));
